import styled from 'styled-components';
import { grayColor } from 'assets/jss/material-dashboard-pro-react';

const TreeWrapper = styled.div`
  margin-top: 20px;
`;

const TreeNodeHeader = styled.h3`
  margin-top: 0;
  margin-bottom: 0;
  margin-left: ${props => (props.indent ? '15px' : 0)};
  padding-bottom: 5px;
  color: ${grayColor[2]};
`;

const TreeViewStyles = {
  TreeWrapper,
  TreeNodeHeader,
};

export default TreeViewStyles;
